module.exports = __webpack_public_path__ + "bb3bfad580d771775ae29bbbedd556ee.png";